import { validate as validateBitcoin } from "bitcoin-address-validation";

export function isAddressBitcoin(value: string) {
  try {
    return validateBitcoin(value);
  } catch {
    return false;
  }
}
